export default __webpack_public_path__ + "static/media/profile.624b2881.png";